export const env = String((window as any).gon?.env);

export const account_uuid = (window as any).gon?.account_uuid;
export const client_uuid = (window as any).gon?.client_uuid;
export const user_uuid = (window as any).gon?.user_uuid;
